import React, { useCallback } from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Box, Button, styled, useTheme } from '@mui/material';
import { Post } from 'src/models/fragments';
import { SupportedLanguages } from 'models/languages';
import LanguageFlags from './LanguageFlags';

const LANGUAGE_NAME: { [key in SupportedLanguages]: string } = {
  ko: '한국어',
  en: 'English',
};

interface Props {
  otherLangPosts: Array<Pick<Post, 'fields'>>;
  onClick?: () => void;
}
const OtherLangPosts = ({ otherLangPosts, onClick }: Props) => {
  const { spacing } = useTheme();

  const handleClick = useCallback(() => {
    onClick?.();
  }, [onClick]);

  return (
    <Box>
      <Ul>
        {otherLangPosts.map(({ fields: post }) => {
          if (post?.path == null || post?.lang == null) {
            return null;
          }

          const lang = post.lang as SupportedLanguages;
          return (
            <Li key={post.path}>
              <Link to={post.path} onClick={handleClick}>
                <Button variant="outlined" size="large">
                  <Box component="span" sx={{ marginRight: spacing(1) }}>
                    <LanguageFlags lang={lang} />
                  </Box>
                  {LANGUAGE_NAME[lang]}
                </Button>
              </Link>
            </Li>
          );
        })}
      </Ul>
    </Box>
  );
};

const noStyled = {
  margin: 0,
  padding: 0,
  listStyle: 'none',
  textDecoration: 'none',
};

const Ul = styled('ul')(noStyled);
const Li = styled('li')(noStyled);
const Link = styled(GatsbyLink)(noStyled);

export default OtherLangPosts;
